import { portalTranslations, sharedTranslations } from "@lyteflo/assets";
import { fieldLabelsI18n } from "@lyteflo/config/fields";
import { LANGUAGES } from "@lyteflo/types";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const languages = {
  [LANGUAGES.EN]: {
    label: "English",
    value: LANGUAGES.EN,
  },
  [LANGUAGES.FR]: {
    label: "Français",
    value: LANGUAGES.FR,
  },
};

export const i18nInstance = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.keys(languages),
    fallbackLng: LANGUAGES.EN,
    defaultNS: "portal",
    ns: ["portal", "shared", fieldLabelsI18n.ns],
    fallbackNS: fieldLabelsI18n.fallbackNS,
    resources: {
      [LANGUAGES.EN]: {
        portal: portalTranslations.en,
        shared: sharedTranslations.en,
        ...fieldLabelsI18n.resources.en,
      },
      [LANGUAGES.FR]: {
        portal: portalTranslations.fr,
        shared: sharedTranslations.fr,
        ...fieldLabelsI18n.resources.fr,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "lf_language",
      caches: ["localStorage"],
    },
  });

export default i18n;
